import React, { Component } from "react";

import PosterL1 from "./img/Poster_L1.svg";
import PosterL2 from "./img/Poster_L2.svg";

const posters = {
  1: PosterL1,
  2: PosterL2
}

export class ThermocyclerPoster extends Component {

  doneClicked =()=>{
    this.props.showModal({
      display: false
    })
  }

  render() {

    return (
      <div className="modal-section" style={{ margin: 0, padding: 0 }}>
        <img src={posters[this.props.levelSelected.id]} alt="Poster" />
      </div>

    );
  }
}
